import type { LinkProps } from "@remix-run/react";
import { Link } from "@remix-run/react";
import { useMemo } from "react";

export const CKLink = ({
  children,
  to,
  prefetchFn,
  ...props
}: LinkProps & {
  prefetchFn: (to: LinkProps["to"]) => LinkProps["prefetch"];
}) => {
  const _prefetch = useMemo<LinkProps["prefetch"]>(
    () => prefetchFn(to) || "intent",
    [prefetchFn, to]
  );
  return (
    <Link to={to} prefetch={_prefetch} {...props}>
      {children}
    </Link>
  );
};
